import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NavigationComponent } from './components/layout/navigation/navigation.component';
import { MissionControlRoutingModule } from './mission-control-routing.module';
import { LayoutComponent } from './components/layout/layout/layout.component';
import { UiModule } from '../../ui/ui.module';
import { DesktopNavComponent } from './components/layout/desktop-nav/desktop-nav.component';
import { MobileNavComponent } from './components/layout/mobile-nav/mobile-nav.component';
import { BreadcrumbComponent } from './components/layout/breadcrumb/breadcrumb.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
// import { LoginComponent } from './components/user/login/login.component';
import { StyleGuideComponent } from './components/layout/style-guide/style-guide.component';
import { CardComponent } from './components/layout/card/card.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SplitterModule } from 'primeng/splitter';
import { HomeComponent } from './components/common/home/home.component';
import { VerseOfTheDayComponent } from './components/common/verse-of-the-day/verse-of-the-day.component';
import { MissionVisionValuesComponent } from './components/common/mission-vision-values/mission-vision-values.component';
import { PulseComponent } from './components/common/pulse/pulse.component';
import { GlMailComponent } from './components/common/gl-mail/gl-mail.component';
import { KnowBe4GraphsComponent } from './components/common/know-be4-graphs/know-be4-graphs.component';
import { BaseChartDirective, provideCharts } from 'ng2-charts';
import { RegistrationStatsComponent } from './components/common/registration-stats/registration-stats.component';
import { CallStatsComponent } from './components/common/call-stats/call-stats.component';
import { PaymentStatsComponent } from './components/common/payment-stats/payment-stats.component';
import { GoogleAnalyticsPanelComponent } from './components/common/google-analytics-panel/google-analytics-panel.component';
import { RenewalProgressComponent } from './components/departments/recruiting/renewal-progress/renewal-progress.component';
import { MiscStatsComponent } from './components/common/miscellaneous-stats/misc-stats.component';
import { MyRegistrationStatsComponent } from './components/departments/recruiting/my-registration-stats/my-registration-stats.component';
import { MyCallStatsComponent } from './components/departments/recruiting/my-call-stats/my-call-stats.component';
import { MyPotentialTripsComponent } from './components/departments/recruiting/my-potential-trips/my-potential-trips.component';
import { MyConsultingWrapperComponent } from './components/departments/consulting/my-consulting-wrapper/my-consulting-wrapper.component';
import { MyOverdueRegiFeesComponent } from './components/departments/recruiting/my-overdue-regi-fees/my-overdue-regi-fees.component';
import { MyOverduePaymentsComponent } from './components/departments/consulting/my-overdue-payments/my-overdue-payments.component';
import { AllScheduledActivitiesComponent } from './components/common/all-scheduled-activities/all-scheduled-activities.component';
import { MyActivitiesComponent } from './components/common/my-activities/my-activities.component';
import { SupervisorDashboardComponent } from './components/supervisor/supervisor-dashboard/supervisor-dashboard.component';
import { AddAlertComponent } from './components/common/alerts/add-alert/add-alert.component';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { UpdateRegiGoalsComponent } from './components/departments/recruiting/update-regi-goals/update-regi-goals.component';
import { UpdateCallGoalsComponent } from './components/departments/recruiting/update-call-goals/update-call-goals.component';
import { UpdateMyRegiGoalsComponent } from './components/departments/recruiting/update-my-regi-goals/update-my-regi-goals.component';
import { UpdateMyCallGoalsComponent } from './components/departments/recruiting/update-my-call-goals/update-my-call-goals.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { RecruitingDashboardComponent } from './components/departments/recruiting/dashboard/recruiting-dashboard.component';
import { RecruitingScheduledActivitiesComponent } from './components/departments/recruiting/recruiting-scheduled-activities/recruiting-scheduled-activities.component';
import { LocationRecruitingComponent } from './components/departments/recruiting/location-recruiting/location-recruiting.component';
import { RegistrationLeaderboardComponent } from './components/departments/recruiting/registration-leaderboard/registration-leaderboard.component';
import { AssistLeaderboardComponent } from './components/departments/recruiting/assist-leaderboard/assist-leaderboard.component';
import { CallLeaderboardComponent } from './components/departments/recruiting/call-leaderboard/call-leaderboard.component';
import { LocationQuicknotesComponent } from './components/departments/recruiting/location-quicknotes/location-quicknotes.component';
import { MySavedLeadSearchesComponent } from './components/departments/recruiting/my-saved-lead-searches/my-saved-lead-searches.component';
import { NotesModule } from '../../component-modules/notes/notes.module';
import { RecruitingComponentsModule } from 'src/app/component-modules/recruiting-components/recruiting-components.module';
import { TripComponentsModule } from 'src/app/component-modules/trip-components/trip-components.module';
import { ConsultingScheduledActivitiesComponent } from './components/departments/consulting/consulting-scheduled-activities/consulting-scheduled-activities.component';
import { PartnerScheduledActivitiesComponent } from './components/roots/partner-scheduled-activities/partner-scheduled-activities.component';
import { EditLocationQuicknotesComponent } from './components/departments/recruiting/edit-location-quicknotes/edit-location-quicknotes.component';
import { TripActualHistoryReportContainerComponent } from '../executive-reporting/trip-actual-history-report-container/trip-actual-history-report-container.component';
import { TableHeaderComponent } from 'src/app/ui/tables/table-header/table-header.component';
import { TableColumnComponent } from 'src/app/ui/tables/table-column/table-column.component';
import { TableCaptionComponent } from 'src/app/ui/tables/table-caption/table-caption.component';
import { TableColumnsComponent } from 'src/app/ui/tables/table-columns/table-columns.component';
import { TableHeadersComponent } from "../../ui/tables/table-headers/table-headers.component";
import { NavSearchComponent } from './components/layout/nav-search/nav-search.component';
import { IndividualStaffKpiReportComponent } from '../kpi/individual-staff-kpi-report/individual-staff-kpi-report.component';
import { Ppm365Module } from '../ppm365/ppm365.module';
import { TripsModule } from '../trips/trips.module';
import { PaymentStatsGraphComponent } from './components/departments/finance/payment-stats-graph/payment-stats-graph.component';
import { PaymentProgressComponent } from './components/departments/finance/payment-progress/payment-progress.component';
import { OriginalRegistrationStatsGraphComponent } from './components/departments/recruiting/original-registration-stats-graph/original-registration-stats-graph.component';
import { CallProgressComponent } from './components/departments/recruiting/call-progress/call-progress.component';
import { CallStatsGraphComponent } from './components/departments/recruiting/call-stats-graph/call-stats-graph.component';
import { GlMailItemComponent } from './components/common/gl-mail-item/gl-mail-item.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ChipModule } from 'primeng/chip';
import { BadgeModule } from 'primeng/badge';
import { TooltipModule } from 'primeng/tooltip';
import { RecruitingModule } from '../recruiting/recruiting.module';
import { PhotoboothApprovalComponent } from './components/common/photobooth-approval/photobooth-approval.component';
import { SharedMissionVisionValuesComponent, ThemeNavPickerComponent } from '@shared';

@NgModule({
  declarations: [
    NavigationComponent,
    DesktopNavComponent,
    MobileNavComponent,
    LayoutComponent,
    // LoginComponent,
    BreadcrumbComponent,
    StyleGuideComponent,
    CardComponent,
    HomeComponent,
    VerseOfTheDayComponent,
    MissionVisionValuesComponent,
    PulseComponent,
    GlMailComponent,
    KnowBe4GraphsComponent,
    AddAlertComponent,
    UpdateRegiGoalsComponent,
    UpdateCallGoalsComponent,
    UpdateMyRegiGoalsComponent,
    UpdateMyCallGoalsComponent,
    RecruitingDashboardComponent,
    EditLocationQuicknotesComponent,
    PhotoboothApprovalComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    MissionControlRoutingModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    SplitterModule,
    BaseChartDirective,
    TripActualHistoryReportContainerComponent,
    CardModule,
    ButtonModule,
    InputTextModule,
    CalendarModule,
    InputNumberModule,
    NotesModule,
    RecruitingComponentsModule,
    TripComponentsModule,
    TableHeaderComponent,
    TableColumnComponent,
    TableColumnsComponent,
    TableHeadersComponent,
    TableCaptionComponent,
    NavSearchComponent,
    IndividualStaffKpiReportComponent,
    Ppm365Module,
    GlMailItemComponent,
    ScrollPanelModule,
    ChipModule,
    BadgeModule,
    TooltipModule,
    TripsModule,
    // Standalone components
    RegistrationStatsComponent,
    CallStatsComponent,
    PaymentStatsComponent,
    PaymentStatsGraphComponent,
    PaymentProgressComponent,
    OriginalRegistrationStatsGraphComponent,
    CallProgressComponent,
    CallStatsGraphComponent,
    GoogleAnalyticsPanelComponent,
    RenewalProgressComponent,
    MiscStatsComponent,
    MyRegistrationStatsComponent,
    MyCallStatsComponent,
    MyPotentialTripsComponent,
    MyConsultingWrapperComponent,
    MyOverdueRegiFeesComponent,
    MyOverduePaymentsComponent,
    RecruitingScheduledActivitiesComponent,
    ConsultingScheduledActivitiesComponent,
    PartnerScheduledActivitiesComponent,
    AllScheduledActivitiesComponent,
    MyActivitiesComponent,
    SupervisorDashboardComponent,
    LocationRecruitingComponent,
    RegistrationLeaderboardComponent,
    AssistLeaderboardComponent,
    CallLeaderboardComponent,
    MySavedLeadSearchesComponent,
    LocationQuicknotesComponent,
    RecruitingModule,
    SharedMissionVisionValuesComponent,
    ThemeNavPickerComponent
  ],
  providers: [
    ConfirmationService,
    MessageService
  ],
  exports: [
    LayoutComponent
  ]
})
export class MissionControlModule { }
